export const GooglePlayLogo = () => {
  return <img src={require('./google-play.png')} alt='Croppa - Download on Google Play' />;
};
